import { render } from "./PlatformGuide.vue?vue&type=template&id=75dde20a&scoped=true"
import script from "./PlatformGuide.vue?vue&type=script&lang=js"
export * from "./PlatformGuide.vue?vue&type=script&lang=js"

import "./PlatformGuide.vue?vue&type=style&index=0&id=75dde20a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75dde20a"]])

export default __exports__